export default __webpack_public_path__ + "static/media/edit.7af612a9.svg";